import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export interface IGenerateTemplatesForStrategy {
  strategyId: number;
  invitationCharsLimit?: number | null;
}

export default function useGenerateTemplatesForStrategy() {
  const queryClient = useQueryClient();

  const generateTemplatesForStrategy = (
    payload: IGenerateTemplatesForStrategy,
  ) => {
    const request: Request = {
      url: `${ENDPOINTS.assistant.strategy.templates.generate}`,
      config: {
        method: 'post',
        data: { data: payload },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    IGenerateTemplatesForStrategy
  >(generateTemplatesForStrategy, {
    onSettled: (result, error, variables) => {
      queryClient.invalidateQueries([
        ENDPOINTS.strategy.main,
        variables.strategyId,
      ]);
    },
  });

  return { data, mutate, ...rest };
}
